const GENERATOR = 0
const MAN_GENERATOR = 1
const MANIFESTOR = 2
const PROJECTOR = 3
const REFLECTOR = 4

export default { GENERATOR, MAN_GENERATOR, MANIFESTOR, PROJECTOR, REFLECTOR }
